/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit VirtualizedList/view.blocks to change it.
import Children from 'Simple/Children'
import React from 'react'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'



/** @type {import('Simple/types.js').View} */
export default function VirtualizedList({
  children,
  viewPath = "/DesignSystem/VirtualizedList",
  innerRef,
  paddingTop = 0,
  paddingLeft = 0,
  paddingRight = 0,
  paddingBottom = 0
  
}) {
  let isBefore = useIsBefore()
  return (<React.Fragment
>
<div
  data-testid="VirtualizedList.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="VirtualizedList.Vertical:1"
  data-view-path={viewPath}
 ref={innerRef}
 contain="strict"
 style={{'--pt-2-10yMHj': typeof paddingTop === 'number' ? `${paddingTop}px` : paddingTop,'--pl-3-10yMHj': typeof paddingLeft === 'number' ? `${paddingLeft}px` : paddingLeft,'--pr-4-10yMHj': typeof paddingRight === 'number' ? `${paddingRight}px` : paddingRight,'--pb-5-10yMHj': typeof paddingBottom === 'number' ? `${paddingBottom}px` : paddingBottom,'--o-1-10yMHj': isBefore ? 0 : 1}}
 className={`views-block ${styles.Vertical1}`}
>
<Children
  viewPath={`${viewPath}/Children`}
>
{children}
</Children>
</div>
</div>
</React.Fragment>)
}